import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useAxiosPrivate } from "../useAxiosPrivate";

export default function useWorktimeQueries() {
    const axiosPrivate = useAxiosPrivate();
    const queryClient = useQueryClient();

    // QUERIES ------------------------------------------------------

    const useWorktimeQuery = (id) =>
        useQuery({
            queryKey: ["worktime", id],
            queryFn: ({ queryKey }) => {
                const [, worktimeId] = queryKey;
                return axiosPrivate
                    .get(`worktime/${worktimeId}/`)
                    .then(r => r.data);
            },
            enabled: !!id,
        });

    const useWorktimeUserQuery = (id) =>
        useQuery({
            queryKey: ["worktime", id],
            queryFn: ({ queryKey }) => {
                const [, userId] = queryKey;
                return axiosPrivate
                    .get(`worktime/${userId}/get-for-user/`)
                    .then(r => r.data);
            },
            enabled: !!id,
        });

    const worktimeListQuery = useQuery({
        queryKey: ["worktime", "list"],
        queryFn: () =>
            axiosPrivate
                .get("worktime/")
                .then(r => r.data),
    });

    // MUTATIONS ------------------------------------------------------

    const createWorktimeMutation = useMutation({
        mutationFn: (data) =>
            axiosPrivate.post("worktime/", data).then(r => r.data),
        onSuccess: () => {
            queryClient.invalidateQueries(["worktime"]);
        },
    });

    const updateWorktimeMutation = useMutation({
        mutationFn: ({ id, data }) =>
            axiosPrivate.patch(`worktime/${id}/`, data).then(r => r.data),
        onSuccess: () => {
            queryClient.invalidateQueries(["worktime"]);
        },
    });

    const deleteWorktimeMutation = useMutation({
        mutationFn: (id) =>
            axiosPrivate.delete(`worktime/${id}/`).then(r => r.data),
        onSuccess: () => {
            queryClient.invalidateQueries(["worktime"]);
        },
    });

    return {
        // queries
        useWorktimeQuery,
        worktimeListQuery,
        useWorktimeUserQuery,

        // mutations
        createWorktimeMutation,
        updateWorktimeMutation,
        deleteWorktimeMutation,
    };
}
